import React, { Component } from "react";
import { getDb, setDb, sendArrayDb } from "../C18AiUtils";
import { cl,globs } from "../../../components/utils/utils";

const CHAN = 240;
const TAB = "pearl_gen_sens_alrm";

const idxEC1 = 1;
const idxEC2 = 2;
const idxpH1 = 3;
const idxpH2 = 4;
const idxTemp = 5;
const idxFlow = 6;
const idxVolume = 7;

const SENSOR_KEYS = ["EC1", "EC2", "pH1", "pH2", "Temp", "Flow", "Volume"];

const FIELD_ROWS = [
  { label: "Alarm Low", field: "alarmLow",min:0,max:3000},
  { label: "Alarm High", field: "alarmHigh",min:0,max:3000 },
  { label: "Deadband", field: "alarmDeadband",min:0,max:200 },
  { label: "Delay", field: "alarmDelay",min:0,max:60 },
  { label: "Notify How Often", field: "notifyHowOften",min:0,max:1440 },
  { label: "Notifications / Day", field: "notifyPerDay",min:0,max:50 },
];

const defaultSensor = (idx) => ({
  idx,
  alarmEnable: 0,
  alarmLow: "0",
  alarmHigh: "0",
  alarmDeadband: "0",
  alarmDelay: "0",
  notifyHowOften: "0",
  notifyPerDay: "0",
});

export default class DoserAlarmSettings extends Component {
  state = {
    sensors: {
      EC1: defaultSensor(idxEC1),
      EC2: defaultSensor(idxEC2),
      pH1: defaultSensor(idxpH1),
      pH2: defaultSensor(idxpH2),
      Temp: defaultSensor(idxTemp),
      Flow: defaultSensor(idxFlow),
      Volume: defaultSensor(idxVolume),
    },
  };

  componentDidMount() {
    const { zInd } = this.props;

    const loadSensor = (idx) => ({
      alarmEnable: Number(getDb(zInd, CHAN, TAB, "alarmEnable", idx)) || 0,
      alarmLow: String(getDb(zInd, CHAN, TAB, "alarmLow", idx) ?? 0),
      alarmHigh: String(getDb(zInd, CHAN, TAB, "alarmHigh", idx) ?? 0),
      alarmDeadband: String(getDb(zInd, CHAN, TAB, "alarmDeadband", idx) ?? 0),
      alarmDelay: String(getDb(zInd, CHAN, TAB, "alarmDelay", idx) ?? 0),
      notifyHowOften: String(getDb(zInd, CHAN, TAB, "notifyHowOften", idx) ?? 0),
      notifyPerDay: String(getDb(zInd, CHAN, TAB, "notifyPerDay", idx) ?? 0),
    });

    this.setState({
      sensors: {
        EC1: { idx: idxEC1, ...loadSensor(idxEC1-1) },
        EC2: { idx: idxEC2, ...loadSensor(idxEC2-1) },
        pH1: { idx: idxpH1, ...loadSensor(idxpH1-1) },
        pH2: { idx: idxpH2, ...loadSensor(idxpH2-1) },
        Temp: { idx: idxTemp, ...loadSensor(idxTemp-1) },
        Flow: { idx: idxFlow, ...loadSensor(idxFlow-1) },
        Volume: { idx: idxVolume, ...loadSensor(idxVolume-1) },
      },
    });

    this.subscribe_savePageEvent = globs.events.subscribe("savePageEvent", this.savePage);
  }

  componentWillUnmount() {
    if (this.subscribe_savePageEvent && this.subscribe_savePageEvent.remove) {
      this.subscribe_savePageEvent.remove();
    }
  }

  handleChange = (sensorKey, field, value, min, max) => {
    if((value>max)||(value<min)){return}
    this.setState((prev) => ({
      sensors: {
        ...prev.sensors,
        [sensorKey]: {
          ...prev.sensors[sensorKey],
          [field]: value,
        },
      },
    }));

    globs.events.publish("savePageEnable", true);
    this.props.onChange({type:"change",value:this.savePage})
  };

  savePage = async () => {
    cl("savePage")
    const { sensors } = this.state;
    const { zInd } = this.props;

    const toNum = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    };

    let arr = [];

    Object.values(sensors).forEach((sensor) => {
//       cl(sensor)
      const idx = sensor.idx-1;

      setDb(arr, zInd, CHAN, TAB, "alarmEnable", idx, sensor.alarmEnable ? 1 : 0);
      setDb(arr, zInd, CHAN, TAB, "alarmLow", idx, toNum(sensor.alarmLow));
      setDb(arr, zInd, CHAN, TAB, "alarmHigh", idx, toNum(sensor.alarmHigh));
      setDb(arr, zInd, CHAN, TAB, "alarmDeadband", idx, toNum(sensor.alarmDeadband));
      setDb(arr, zInd, CHAN, TAB, "alarmDelay", idx, toNum(sensor.alarmDelay));
      setDb(arr, zInd, CHAN, TAB, "notifyHowOften", idx, toNum(sensor.notifyHowOften));
      setDb(arr, zInd, CHAN, TAB, "notifyPerDay", idx, toNum(sensor.notifyPerDay));
    });
//     cl(arr)

    await sendArrayDb(arr);
  };

  render() {
    const { sensors } = this.state;

    const isValidNumber = (v,min,max) => {
      if (v === "" || v === null || v === undefined) return true;
      return (!isNaN(Number(v))&&(+v>=min)&&(+v<=max));
    };

    const labelStyle = {
      fontSize: 12,
      color: "#666",
      display: "block",
      marginBottom: 4,
    };

    return (
      <div
        style={{
          fontFamily: "system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
          padding: 8,
        }}
      >
      <h3>Alarm Settings</h3>
        {SENSOR_KEYS.map((sensorKey) => {
          const sensor = sensors[sensorKey];
//           cl(sensor)
//           cl(sensorKey)
          return (
            <div key={sensorKey} style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  style={{minWidth:0,marginRight:20}}
                  checked={sensor.alarmEnable === 1}
                  onChange={(e) =>
                    this.handleChange(sensorKey, "alarmEnable", e.target.checked ? 1 : 0,0,1)
                  }
                />
                <div style={{ width: "120px" }}>
                  {sensorKey} Enable
                </div>

              </div>

              <div
                style={{
                  display: sensor.alarmEnable ? "flex" : "none",
                  gap: "12px",
                  flexWrap: "wrap",
                  marginTop: "8px",
                  marginBottom: "20px",
                }}
              >
                {FIELD_ROWS.map(({ label, field, min, max }) => (
                  <div
                    key={field}
                    style={{
                      width: "120px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label style={labelStyle}>{label}</label>
                    <input
                      type="number"
                      step="1"
                      min={min}
                      max={max}
                      style={{
                        width: "100px",
                        borderColor: isValidNumber(sensor[field],min,max) ? "#ccc" : "#d32f2f",
                      }}
                      value={sensor[field]}
                      onChange={(e) =>
                        this.handleChange(sensorKey, field, e.target.value,min,max)}
                    />
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
